export * from './image.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/advtech/image/index.ts